import { Fragment, useContext, useEffect, useState } from "react";
import { Container, Row, Col, Image, Form, FloatingLabel, Button } from "react-bootstrap";
import BrandContext from "./BrandContext";
import { states } from "./data";
import useAxios from "axios-hooks";
export default function MeetingRequest(props) {
    const theme = useContext(BrandContext);
    const [formState, setFormState] = useState({})
    const [isValid, setIsValid] = useState(false)

    useEffect(() => {
        setIsValid(!!formState['email'] && !!formState['phone'] &&
            !!formState['name'] && !!formState['company'] && !!formState['role']
            && !!formState['country'] && !!formState['state'] && !!formState['permission'])
    }, [formState]);

    function setInput(key, value) {
        const newVal = { [key]: value }
        if (key === 'country') newVal.state = ''
        setFormState({ ...formState, ...newVal })
    }
    const [
        { data, loading, error },
        executePut
    ] = useAxios(
        {
            url: '/pr/meeting-request',
            method: 'POST'
        },
        { manual: true }
    )
    function submit() {
        executePut({
            data: {
                accountId: theme.accountId,
                brandId: theme.brandId,
                meetingRequest: formState
            }
        })
    }
    return (
        <Fragment>
            <Container fluid="md" style={{ paddingTop: "50px", paddingBottom: "50px" }}>
                {!loading && !error && data &&
                    <Row className="justify-content-md-center">
                        <Col md="8" style={{ textAlign: "center" }}>
                            <div>
                                <Image style={{ height: "100px" }} fluid src={theme?.marketing?.logo}></Image>
                            </div>
                            <br />
                            <p className="fw-bold" style={{ fontSize: "40px" }}><strong>Confirmed!</strong></p>
                            <p><strong>Your meeting request has been sent. We'll be in touch, shortly, to coordinate a time.</strong></p>
                        </Col>
                    </Row>
                }
                {!data &&
                    <Row className="justify-content-md-center">
                        <Col md="5">
                            <div>
                                <Image style={{ height: "100px" }} fluid src={theme?.marketing?.logo}></Image>
                            </div>
                            <br />
                            <p className="fw-bold" style={{ fontSize: "32px" }}>Request a Meeting</p>
                            <p>On the right, provide contact info and availability and we'll be back in touch shortly!</p>
                            <p>Here is what you can expect in your 1-on-1 meeting:</p>
                            <ul>
                                <li>A review of your marketing initiatives</li>
                                <li>Additional detail on our marketing solutions and audience</li>
                                <li>Personalized pricing discussion, based on your specific needs</li>
                            </ul>
                        </Col>
                        <Col md="5"  >
                            <Form noValidate >
                                <Form.Group className="mb-3" controlId="customer.email">
                                    <Form.Label className="fw-bold">Email Address</Form.Label>
                                    <Form.Control required type="email" onChange={event => setInput('email', event.target.value)} />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="customer.phone">
                                    <Form.Label className="fw-bold" >Phone Number</Form.Label>
                                    <Form.Control required type="text" onChange={event => setInput('phone', event.target.value)} />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="customer.name">
                                    <Form.Label className="fw-bold" >First and Last Name</Form.Label>
                                    <Form.Control required type="text" onChange={event => setInput('name', event.target.value)} />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="customer.company">
                                    <Form.Label className="fw-bold" >Company</Form.Label>
                                    <Form.Control required type="text" onChange={event => setInput('company', event.target.value)} />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="customer.role">
                                    <Form.Label className="fw-bold">What best describes you?</Form.Label>
                                    <Form.Select required onChange={event => setInput('role', event.target.value)}>
                                        <option></option>
                                        <option value="marketer">Corporate Marketer</option>
                                        <option value="pr">PR Firm / Agency</option>
                                    </Form.Select>
                                </Form.Group>
                                <Row className="mb-3">
                                    <Form.Group as={Col} controlId="customer.country">
                                        <Form.Label className="fw-bold">Country</Form.Label>
                                        <Form.Select required onChange={event => { setInput('country', event.target.value) }}>
                                            <option></option>
                                            <option key="US" value="US">United States</option>
                                            <option key="CA" value="CA">Canada</option>
                                        </Form.Select>
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="customer.state">
                                        <Form.Label className="fw-bold">State</Form.Label>
                                        <Form.Select required disabled={!formState.country} onChange={event => setInput('state', event.target.value)}>
                                            <option></option>
                                            {formState.country && states[formState.country].map(s => {
                                                return (<option key={s.abbreviation} value={s.abbreviation}>{s.name}</option>)
                                            })}
                                        </Form.Select>
                                    </Form.Group>
                                </Row>
                                <Form.Group className="mb-3" controlId="customer.extra">
                                    <Form.Label className="fw-bold">Anything else?</Form.Label>
                                    <Form.Control autoFocus as="textarea" rows={4} style={{ resize: "none" }} placeholder="Optional"
                                        minLength={1} maxLength={500} onChange={event => setInput('extra', event.target.value)} />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="customer.permission">
                                    <Form.Check required style={{ margin: "0px" }}
                                        type="switch"
                                        id="contact-checkbox"
                                        label="I give my permission to contact me"
                                        onChange={event => setInput('permission', event.target.value)}
                                    />
                                </Form.Group>
                                <Button disabled={loading || !isValid} variant="swiftrev" onClick={() => submit()}>{loading ? 'Submitting...' : 'Submit'}</Button>
                            </Form>
                        </Col>
                    </Row>
                }
            </Container>
        </Fragment >
    )
}